export default function MySQL_RIGHTJOIN() {
  return (
    <div>
      <h2>MySQL_RIGHTJOIN</h2>    </div>
  );
}